export const COLORS = {
  DEFAULT: "#fff",
  DARK: "#546e7a",
  ERROR: "#dc3545",
  SUCCESS: "#198754",
};
